import { Grid } from "@mui/material";
import React from "react";
import AddressHeader from "./home/header";
import AddressTabel from "./home/table";

const Provinces = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <AddressHeader />
      </Grid>
      <Grid item xs={12}>
        <AddressTabel />
      </Grid>
    </Grid>
  );
};

export default Provinces;
